import { U as Url } from './url.min.js';

/**
 * **UIBS**
 *
 * @exports bs_408
 * @category engines
 */
function factory({ window, document, thn }) {
    const engine = {};
    const dataLayer = window.dataLayer;
    let handler;
    let refreshPrice;
    /**
       * @memberOf module:bs_408
       * @see {@link is_user_logged}
       *
       * @param {object} ctx - The context object.
       */
    engine.isUserLogged = function isUserLogged(ctx) {
        const isLogged = false;
        return isLogged;
    };
    /**
       * @memberOf module:bs_408
       * @see {@link prestart}
       *
       * @param {object} ctx - The context object.
       */
    engine.boot = function boot(ctx) {
        const container = document.querySelector('#body');
        if (container) {
            handler = thn.debounce(thn.pageCheck, 500);
            thn.observeDom(container, handler, {
                childList: true,
                characterData: true,
            });
            thn.shutdown(() => {
                handler.cancel();
                thn.stopObserveDom(container, handler);
                handler = null;
            });
        }
    };
    /**
     * @memberOf module:bs_408
     * @see {@link generate_search_url}
     *
     * @param {object} ctx - The context object.
     */
    engine.generateSearchUrl = function generateSearchUrl(ctx) {
        const url = new Url(ctx.baseUrl);
        const validUrl = !!url.path.match(/Main\.aspx/);
        if (!validUrl) {
            ctx.newUrl = '';
            return ctx;
        }
        url.query.checkin = '[date_begin]';
        url.query.checkout = '[date_end]';
        url.query.adults = '[adults]';
        url.query.children = '[children]';
        ctx.newUrl = url.toString();
        return ctx;
    };
    /**
     * @memberOf module:bs_408
     * @this thn.widgets.price
     * @see {@link Price#observe_dom}
     *
     * @param {object} ctx - The context object.
     */
    engine.priceObserveDom = function priceObserveDom(ctx) {
        const container = document.querySelector('.RadAjaxPanel');
        if (container) {
            refreshPrice = thn.debounce(() => {
                if (document.querySelector('#SearchHotelResults')) {
                    thn.widgets.price.refresh();
                }
            }, 400);
            thn.observeDom(container, refreshPrice, {
                childList: true,
                characterData: true,
            });
            thn.pageUnload(() => {
                refreshPrice.cancel();
                thn.stopObserveDom(container, refreshPrice);
                refreshPrice = null;
            });
        }
    };
    /**
      * @memberOf module:bs_408
      * @this thn.widgets.price
      * @see {@link Price#set_data}
      *
      * @param {object} ctx - The context object.
      */
    engine.priceParseData = function priceParseData(ctx) {
        const widgetData = {};
        // Dates
        let nights;
        const searchedDates = document.querySelector('#ltrBookingDates')?.textContent;
        const dateBegin = searchedDates && thn.dateToString(searchedDates.split('-')[0]);
        const dateEnd = searchedDates && thn.dateToString(searchedDates.split('-')[1]);
        if (dateBegin && dateEnd) {
            widgetData.dateBegin = dateBegin;
            widgetData.dateEnd = dateEnd;
            nights = thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
        }
        // Guests, Adults & Children
        const searchedRooms = [...document.querySelectorAll('[id*=calendarinputroom]')].filter((room) => room?.value);
        const currentRoom = thn.parseNumber(document.querySelector('[class*=ButtonHotelId] a span')?.textContent) || 1;
        const currentRoomGuests = searchedRooms[currentRoom - 1]?.value.split(',');
        const adults = thn.parseNumber(currentRoomGuests?.[0]) || 2;
        const children = thn.parseNumber(currentRoomGuests?.[1]) || 0;
        const infants = thn.parseNumber(currentRoomGuests?.[2]) || 0;
        widgetData.adults = adults;
        widgetData.children = children + infants;
        // Prices & Currency || No Rooms
        const availableRooms = [...document.querySelectorAll('.groupedRates, .info-wrapper')].filter((room) => !room.querySelector('.ItemNotAvailableMessage, .unavailable') && thn.isVisible(room));
        // No availability
        if (thn.empty(availableRooms)) {
            widgetData.noRooms = true;
            return widgetData;
        }
        const prices = availableRooms.map((availRoom) => thn.parseNumber(availRoom.querySelector('.roomCost, .rate-price h5')?.textContent)).filter(Boolean);
        const currency = thn.parseCurrency(document.querySelector('.roomCost, .rate-price')?.textContent);
        if (thn.notEmpty(prices) && currency && nights) {
            widgetData.price = Math.min(...prices);
            widgetData.currency = currency;
            widgetData.set = true;
        }
        return widgetData;
    };
    /**
       * @memberOf module:bs_408
       * @this thn.widgets.booking
       * @see {@link Booking#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.bookingParseData = function bookingParseData(ctx) {
        const widgetData = {};
        const [purchase] = dataLayer.filter((el) => el?.[0] === 'event' && el?.[1] === 'purchase');
        // Dates
        const stayDates = document.querySelector('[id*=ltrBookingDates]')?.textContent.split('-');
        if (thn.notEmpty(stayDates)) {
            const dateBegin = thn.dateToString(stayDates[0]);
            const dateEnd = thn.dateToString(stayDates[1]);
            widgetData.dateBegin = dateBegin;
            widgetData.dateEnd = dateEnd;
        }
        // Booking id
        const bookingId = thn.objectGet(purchase, 'transaction_id') || document.querySelector('.referenceNumber')?.textContent;
        // Price & Currency
        const price = thn.objectGet(purchase, 'value');
        const currency = thn.objectGet(purchase, 'currency');
        widgetData.bookingId = bookingId;
        widgetData.price = price;
        widgetData.currency = currency;
        return widgetData;
    };
    return engine;
}

export { factory };
